import { render, staticRenderFns } from "./selectTextureModel.vue?vue&type=template&id=489957f3&"
import script from "./selectTextureModel.vue?vue&type=script&lang=js&"
export * from "./selectTextureModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports